import React from 'react';
import { motion } from 'framer-motion';
import { inActionImage } from '../data/content';
export function InAction() {
  return <section aria-label="See Pawsy in action" className="bg-cream px-4 py-7 sm:px-8 sm:py-9" data-id="element-79" data-mp="zd2l93p30njm">
      <motion.figure initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.15
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="mx-auto w-full max-w-6xl overflow-hidden rounded-3xl border border-orangey-100 bg-white shadow-card" data-id="element-80" data-mp="146ey6gkef5wj">
        <img src={inActionImage} alt="See Pawsy in action — four app screens showing the personalized nutrition plan, today's daily routine, the safe foods search with grapes marked toxic and blueberries safe, and the Pawsy Guides lesson library" loading="lazy" decoding="async" className="w-full" data-id="element-81" data-mp="ghck1ioz3v6s" />
      </motion.figure>
    </section>;
}